'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _loginForm = require('./login-form');

var _loginForm2 = _interopRequireDefault(_loginForm);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LogInModal = _react2['default'].createClass({
    displayName: 'LogInModal',


    propTypes: {
        'header': _react2['default'].PropTypes.string.isRequired,
        'googleOpenIdUrl': _react2['default'].PropTypes.string,
        'tabOffset': _react2['default'].PropTypes.number,
        'emailAddress': _react2['default'].PropTypes.string,
        'loginUrl': _react2['default'].PropTypes.string,
        'recaptchaPublicKey': _react2['default'].PropTypes.string,
        'displayCaptcha': _react2['default'].PropTypes.bool,
        'recoverPasswordForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'loginForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'redirectUrl': _react2['default'].PropTypes.string,
        'hideRememberMe': _react2['default'].PropTypes.bool
    },

    getInitialState: function getInitialState() {
        return {
            'password': '',
            'emailAddress': this.props.emailAddress,
            'isProcessing': false
        };
    },

    componentDidMount: function componentDidMount() {
        if (!this.props.isInline && this.isFoundationFriendly()) {
            $(document).foundation();
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (!nextProps.isInline && this.isFoundationFriendly()) {
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },

    // Note: version 1.4.4 of jQuery is incompatible with Foundation.
    isFoundationFriendly: function isFoundationFriendly() {
        return window.$ && $.fn.jquery !== "1.4.4";
    },

    render: function render() {

        var cx = _classnames2['default'];
        var rowClassNames = (0, _classnames2['default'])({
            'row': true,
            'text-center': true,
            'bg-plume': this.props.isInline ? true : false,
            'm-login--inline-container': this.props.isInline ? true : false,
            'l-padding-v-20': this.props.isInline ? true : false
        });

        return _jsx(_loginForm2['default'], {
            header: this.props.header,
            buttonText: this.props.buttonText,
            isInline: this.props.isInline,
            inlineSideText: this.props.inlineSideText,
            googleOpenIdUrl: this.props.googleOpenIdUrl,
            redirectUrl: this.props.redirectUrl,
            recaptchaPublicKey: this.props.recaptchaPublicKey,
            displayCaptcha: this.props.displayCaptcha,
            isFromApiPricing: this.props.isFromApiPricing,
            planId: this.props.planId,
            tabOffset: this.props.tabOffset,
            emailAddress: this.props.emailAddress,
            recoverPasswordForm: this.props.recoverPasswordForm,
            action: this.props.loginUrl,
            fields: this.props.loginForm.fields,
            values: this.props.loginForm.values,
            namespace: this.props.loginForm.namespace,
            hideRememberMe: this.props.hideRememberMe
        });
    }
});

module.exports = LogInModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/login-modal.jsx
 ** module id = 752
 ** module chunks = 0
 **/